import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const Map: IconDef = {
  svg: (
    <G>
      <Path d="M9.5 18L2.5 22V6L9.5 2M9.5 18L16.5 22M9.5 18V2M16.5 22L22.5 18V2L16.5 6M16.5 22V6M16.5 6L9.5 2" />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
      strokeWidth: 2,
    };
  },
};
